import { render, staticRenderFns } from "./FilterChips.vue?vue&type=template&id=40faeae7&scoped=true&"
import script from "./FilterChips.vue?vue&type=script&lang=js&"
export * from "./FilterChips.vue?vue&type=script&lang=js&"
import style0 from "./FilterChips.vue?vue&type=style&index=0&id=40faeae7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40faeae7",
  null
  
)

export default component.exports